"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapNotesFieldToTextContent = void 0;
const jmespath_1 = require("jmespath");
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
/**
 * Returns a function that maps a note field object to renderable text content.
 *
 * A note field consists of a `label` and a JMESPath-notation `path` for the field from the
 * `provider` object that is to be rendered. The `path` may reference any top-level
 * (e.g. `notes`) or nested (e.g. `languages[].language`) properties. For arrays, values
 * are mapped to a delimited string.
 *
 * @see https://jmespath.org/
 *
 * @param provider the provider from which the data will be extracted
 * @param missingValueLabel label used when the requested value does not exist on the provider object
 * @returns function that maps a note field to a renderable text content object
 */
const mapNotesFieldToTextContent = (provider, missingValueLabel) => ({ label, path }) => {
    try {
        const value = (0, jmespath_1.search)(provider, path);
        if ((0, isEmpty_1.default)(value) ||
            (!Array.isArray(value) && typeof value === 'object')) {
            return {
                label: missingValueLabel ? label : '',
                value: missingValueLabel ? `<p>${missingValueLabel}</p>` : ''
            };
        }
        if (Array.isArray(value)) {
            return {
                label,
                value: `<ul>${value
                    .map((v) => `<li>${v}</li>`)
                    .sort()
                    .join('')}</ul>`
            };
        }
        // TODO - Find a better way to handle text formatted using \n and \t
        if (/\n/g.test(value)) {
            return {
                label,
                value: `<p>${value.replace(/\n/g, '<br>')}</p>`
            };
        }
        return {
            label,
            value: `<p>${value}</p>`
        };
    }
    catch (e) {
        // Value for the specified path could not be found.
        return {
            label: missingValueLabel ? label : '',
            value: missingValueLabel ? `<p>${missingValueLabel}</p>` : ''
        };
    }
};
exports.mapNotesFieldToTextContent = mapNotesFieldToTextContent;
//# sourceMappingURL=mapNotesFieldToTextContent.js.map